import Highcharts from "highcharts";

export const initHighchartsModules = () => {
  try {
    const exportingModule = require("highcharts/modules/exporting");
    const exportDataModule = require("highcharts/modules/export-data");
    const offlineExportingModule = require("highcharts/modules/offline-exporting");

    const exporting = exportingModule?.default || exportingModule;
    const exportData = exportDataModule?.default || exportDataModule;
    const offlineExporting =
      offlineExportingModule?.default || offlineExportingModule;

    const moreModule = require("highcharts/highcharts-more");
    const solidGaugeModule = require("highcharts/modules/solid-gauge");

    const HighchartsMore = moreModule?.default || moreModule;
    const SolidGauge = solidGaugeModule?.default || solidGaugeModule;

    if (typeof exporting === "function") exporting(Highcharts);
    if (typeof exportData === "function") exportData(Highcharts);
    if (typeof offlineExporting === "function") offlineExporting(Highcharts);

    if (typeof HighchartsMore === "function") HighchartsMore(Highcharts);
    if (typeof SolidGauge === "function") SolidGauge(Highcharts);
  } catch (err) {
    console.error("Error initializing Highcharts modules:", err);
  }
};
